import React, { useState, useEffect } from "react";
import TopNavbar from "../components/TopNavbar/TopNavbar";
import Table from "../components/Table/Table";
import NewCarType from "./NewCarType";
import SearchBar from "../components/SearchBar/SearchBar";
import ApiManager from "../ApiManager/ApiManager";
import Modal from "../components/Modal/Modal";
import ViewEntity from "../components/ViewEntity/ViewEntity";
import { useAuth } from "../components/AuthProvider";
import { hasPermission, ShowButton } from "../components/RoleBasedComponents";
import PERMISSIONS from "../permissions";
import { useComponentLoading } from "../utils/useComponentLoading";

const columns = [
  { field: "name", headerName: "Vehicle Name" },
  { field: "description", headerName: "Description" },
  { field: "fuel_capacity_cng", headerName: "Fuel Capacity (CNG) in Liters" },
  { field: "max_km_in_full_cng", headerName: "Max KM in Full CNG" }
];

function CarTypes() {
  const { userPermissions } = useAuth();
  const { withLoading, isLoading, getProgress, getMessage, updateProgress } = useComponentLoading();

  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(true);
  const [isEdit, setEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const fetchData = async () => {
    try {
      await withLoading('carTypes', async (onProgress) => {
        onProgress(10, 'Preparing to fetch car types...');
        
        const params = new URLSearchParams({
          page_size: 12,
          page: currentPage,
        });
        
        onProgress(30, 'Fetching car types data...');
        const response = await ApiManager.getCarType(params);
        
        if (!response.ok) throw new Error("Failed to fetch car types");
        
        onProgress(60, 'Processing car types data...');
        const json = await response.json();
        
        onProgress(90, 'Updating car types display...');
        setData(json);
        setHasMorePages(json.length == 12);
        
        onProgress(100, 'Car types loaded successfully');
      }, 'Loading car types...');
    } catch (error) {
      console.error("Error fetching cars:", error);
      setHasMorePages(false);
    }
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleDetails = () => {
    console.log("Details clicked for row:");
    setDetails(true);
    setEdit(false);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const buttons = [{ label: "Details", onClick: () => handleDetails() }];

  const rows = (data || []).map((item) => ({
    id: item.id,
    name: item.name,
    description: item.description,
    fuel_capacity_cng: item.fuel_capacity_cng,
    max_km_in_full_cng: item.max_km_in_full_cng
  }));

  return (
    <div>
      <TopNavbar
        title="Car Types"
      />

      <div
        style={{
          display: "flex",
          justifyContent: "right",
          width: "100%",
          paddingTop: "20px",
          height: "5vh",
        }}
      >
        {/* <SearchBar /> */}
        <ShowButton permission={PERMISSIONS.VENDOR_CAR_TYPE_CREATE}>
          <NewCarType onSuccess={fetchData}/>
        </ShowButton>
      </div>
      <Table
        table_columns={columns}
        view_columns={columns}
        rows={rows}
        setRowsId={setRowId}
        buttons={buttons}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        hasMorePages={hasMorePages}
        isLoading={isLoading('carTypes')}
        loadingMessage={getMessage('carTypes')}
        loadingProgress={getProgress('carTypes')}
      />
      {isModalOpen && isDetails && (
        <div className="details-container">
          <Modal isOpen={true} onClose={handleModalClose}>
            <ViewEntity
              id={rowId}
              fetchFunction={ApiManager.getCarType}
              columns={columns}
              entity="carTypeId"
            />
          </Modal>
        </div>
      )}
    </div>
  );
}

export default CarTypes;
